// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae3fc66a","849":"62467088"}[chunkId] + ".chunk.js";
};